export function SET_LOG_SELECTED(state, log) {
  state.log_selected = log;
}
export function SET_AREA_SELECTED_LOGS(state, area) {
  state.area_selected = area;
}
export function SET_LOGBOOK_VIEW(state, value) {
  state.logBookView = value;
}
export function SET_LOGBOOK_CAPTURE_COUNT(state, count) {
  state.captureCount = count;
}
export function ADD_TO_EVIDENCES(state, evidence) {
  state.evidences.push(evidence);
}
export function SET_EDIT(state, value){
  state.log_edit = value
}
export function SET_SUBJECT(state, value){
  state.subject_edit = value;
}
export function SET_DATE(state, value){
  state.date_edit = value;
}
export function SET_DESCRIPTION(state, value){
  state.descripton_edit = value;
}
export function CLEAR_STATE(state) {
  state.log_selected = null;
  state.area_selected = null;
  state.logBookView = false;
  state.captureCount = 0;
  state.evidences = [];
  state.log_edit = false;
  state.subject_edit = "";
  state.date_edit = null;
  state.descripton_edit = "";
}

export function CLEAR_STATE_LOG_LIST(state) {
  state.log_selected = null;
  state.logBookView = false;
  state.captureCount = 0;
  state.evidences = [];
  state.log_edit = false;
  state.subject_edit = "";
  state.date_edit = null;
  state.descripton_edit = "";
}
